import { isGymWearLog } from './gymShelf.js'
import { sessionStartedAt } from './wearSessions.js'
import { localDayISO } from './localDay.js'
import { buildWearLogEntry } from './wearLogContext.js'

export function latestGymDefault(logs, fragrances, ownerId) {
  if (!ownerId) return null
  const history = logs.filter(row => row.user_id === ownerId && isGymWearLog(row))
    .slice().sort((a,b) => Date.parse(sessionStartedAt(b))-Date.parse(sessionStartedAt(a)))
  for (const log of history) {
    const bottle = fragrances.find(row => row.id === log.fragrance_id)
    const fragrance = bottle && bottle.user_id === ownerId && !bottle.finished_at && !bottle.given_away && !bottle.deleted_at && !bottle.is_finished && !bottle.archived_at ? bottle : null
    if (!fragrance) continue
    const initial = (log.applications || []).find(row => !row.is_reapplication)
    const raw = initial ? initial.sprays : log.sprays
    if (raw == null || raw === '') return null
    const sprays = Number(raw)
    if (!Number.isInteger(sprays) || sprays < 1 || sprays > 30) return null
    return { fragrance, sprays }
  }
  return null
}

export function gymQuickPayload(defaults, now = new Date()) {
  if (!defaults?.fragrance || !Number.isInteger(defaults.sprays)) throw Error('Choose your gym scent and sprays first.')
  return [{...buildWearLogEntry(defaults.fragrance, {date:localDayISO(now),occasion:'Gym',eveningContext:'gym',sprays:defaults.sprays}),wear_label:'gym'}, {applied_at:now.toISOString(),sprays:defaults.sprays}]
}

export function gymTemperature(log) {
  const weather=log?.context_weather
  const captured=Date.parse(weather?.fetched_at)
  const applied=Date.parse(sessionStartedAt(log || {}))
  return log?.context_source === 'auto_ip' && Number.isFinite(Date.parse(log.context_captured_at)) && Math.abs(Date.parse(log.context_captured_at)-applied)<=3600000 && Number.isFinite(weather?.temp_c) && weather.temp_c>=-60 && weather.temp_c<=60 && Number.isFinite(captured) && Number.isFinite(applied) && captured<=Date.now() && Math.abs(captured-applied)<=3600000 ? `${Math.round(weather.temp_c*9/5+32)}°F` : null
}

export function gymWindowStart(now = new Date()) {
  const instant = now instanceof Date ? new Date(now) : new Date(now)
  if (Number.isNaN(instant.getTime())) return null
  const start = new Date(instant)
  start.setHours(4, 0, 0, 0)
  if (instant < start) start.setDate(start.getDate() - 1)
  return start
}

// Gym is a once-per-morning shortcut rather than a midnight calendar reset.
// Keep the stored wear date truthful, but hold the Home summary/action state
// until the next local 4 AM boundary.
export function exactCurrentGymWear(logs, rawFragrances, ownerId, now = new Date()) {
  if (!ownerId) return null
  const start = gymWindowStart(now)
  const end = now instanceof Date ? now : new Date(now)
  if (!start || Number.isNaN(end.getTime())) return null
  const log = logs.filter(row => {
    const appliedAt = new Date(sessionStartedAt(row))
    return row.user_id === ownerId
      && isGymWearLog(row)
      && !Number.isNaN(appliedAt.getTime())
      && appliedAt >= start
      && appliedAt <= end
  }).slice().sort((a,b) => Date.parse(sessionStartedAt(b))-Date.parse(sessionStartedAt(a)))[0]
  if (!log) return null
  const fragrance = rawFragrances.find(row => row.id === log.fragrance_id && row.user_id === ownerId && !row.deleted_at) || null
  return { log, fragrance, appliedAt: Date.parse(sessionStartedAt(log)) }
}

export function exactTodayGymWear(logs, rawFragrances, ownerId, day = localDayISO()) {
  if (!ownerId) return null
  const log = logs.filter(row => row.user_id === ownerId && row.worn_on === day && isGymWearLog(row))
    .slice().sort((a,b) => Date.parse(sessionStartedAt(b))-Date.parse(sessionStartedAt(a)))[0]
  if (!log) return null
  const fragrance = rawFragrances.find(row => row.id === log.fragrance_id && row.user_id === ownerId && !row.deleted_at) || null
  return { log, fragrance, appliedAt: Date.parse(sessionStartedAt(log)) }
}
